import React, { createContext, useContext, useState, ReactNode, useMemo, useCallback } from 'react';
import { ITransactionParameters } from '../interface/transaction';

interface TransactionParameterContextType {
  parameters: ITransactionParameters | null;
  updateParameters: (transactionData: ITransactionParameters) => void;
}

const TransactionParameterContext = createContext<TransactionParameterContextType | undefined>(
  undefined,
);

export const TransactionParameterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [transactionParameter, setTransactionParameter] = useState<ITransactionParameters | null>(
    null,
  );

  const updateTransactionParameter = useCallback((data: ITransactionParameters) => {
    setTransactionParameter(data);
  }, []);

  const transactionContextValue = useMemo(
    () => ({ parameters: transactionParameter, updateParameters: updateTransactionParameter }),
    [transactionParameter, updateTransactionParameter],
  );
  return (
    <TransactionParameterContext.Provider value={transactionContextValue}>
      {children}
    </TransactionParameterContext.Provider>
  );
};

export const useTransactionParameters = () => {
  const context = useContext(TransactionParameterContext);
  if (!context) {
    throw new Error('useTransactionParameters must be used within a TransactionParameterProvider');
  }
  return context;
};
